import React, { useState } from 'react'
import logoimg from '../../assets/MK1.3.png';
import senddata from "../../Data/data.js";
import {  useNavigate } from 'react-router-dom';
import {setToken,getToken,removeToken} from "../../Data/authToken.js";

function LogeIn() {
  const navigate = useNavigate()
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const saveOrUpdateData = async (token) => {
    try {
        setToken(token);
    } catch (error) {
        console.error('Error saving token:', error);
    }
};

  const handleClick = ()=>{
    if (email&&password){
      const data = { email, password };
      senddata("teacher/login", data, "POST").then((res) => {
        if (res.status !== 200) {
        alert('ادخل بياتات صحيحة');
        } else {
        // let token = res.config.headers["set-cookie"][0]
        let token = res.data.access_token;
        saveOrUpdateData(token);
        navigate("/paging")
        }
        });
    }else {
      alert("ادخل الايميل و االباسوورد")
    }
  }


  return (
    <div>
      <div className=' bg-[white] text-[#91918f] flex flex-col min-h-screen text-xl font-bold pb-40 text-right  '>
        <img className=' w-[70%] ml-[15%] mt-[40px] rounded-full' src={logoimg} alt="mohamed khamis" />
        <div>
          <div className='flex flex-col p-20 mt-4'>
            <span>الايميل</span>
            <input 
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="bg-transparent border-b-2 border-[#e44d73] focus:outline-none p-2 text-right "
              />
          </div>
          <div className='flex flex-col px-20'>
            <span>الباسوورد</span>
            <input 
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-transparent border-b-2 border-[#e44d73] focus:outline-none p-2 text-right "
              />
          </div>
        </div>
        <span onClick={handleClick} className='ml-auto mr-auto px-20 py-4 text-[white] bg-[#e44d73] rounded-full mt-[80px] cursor-pointer'>تسجيل </span> 
      </div>
    </div>
  )
}

export default LogeIn
